import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { CompanyAccount } from "model";
import { useEffect } from "react";
export default function CaptureTemplateDetailsOffetAcctDDOpen(props) {
  const context = useBCMSContext();
  const { branding } = context.state;
  BCMSRecord.globalControllerFor(Classes, context);

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update([ "template", "secCode" ], "PPD Credit - Consumer Credit")
    .update([ "template", "name" ], "New Payroll")
    .update([ "template", "companyDiscretionaryData" ], "Bi-Weekly")
    .update([ "template", "companyEntryDescription" ], "Payroll")
    .update([ "template", "companyAccount" ], CompanyAccount.initByID(0))
    .submit();
    
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showSecCode", "isActive" ], true)
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "offsetAccountSelectIsActive", "isActive" ], true)
    .submit();
     useEffect(() => {
            Util.replaceDOMDataPointValues(branding);
        });
  return (
    <TemplateDetailsPage data={data} ui={ui} />
  )
}
